import React from "react";
import { Box } from "@mui/material";
import ReactECharts from "echarts-for-react";

const PageStatisticsChart = ({ data, name, lineColor, height, width }) => {
  const sortedKeys = Object.keys(data ?? {})?.sort((a, b) => {
    const freqA = parseInt(a.split("_").pop(), 10);
    const freqB = parseInt(b.split("_").pop(), 10);
    return freqA - freqB;
  });

  const frequencies = sortedKeys?.map((key) => key.split("_").pop());
  const values = sortedKeys?.map((key) => data[key]);

  const options = {
    title: {
      text: name,
      left: "center",
    },
    xAxis: {
      type: "category",
      data: frequencies,
      name: "Frequency (Hz)",
      nameLocation: "middle",
      nameGap: 30,
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 100,
      name: "Sound Pressure Level (dB)",
      nameLocation: "middle",
      inverse: true,

      nameGap: 40,
      splitLine: {
        show: true,
      },
      splitArea: {
        show: true,
        areaStyle: {
          color: ["#E0F8E7", "#F2FBF5", "#FFF8EB", "#FCEBD8", "#FFC8C9"],
        },
      },
    },
    series: [
      {
        data: values ?? [],
        type: "line",
        lineStyle: { color: lineColor },
        itemStyle: { color: lineColor },
      },
    ],
    grid: {
      left: "10%",
      right: "5%",
      bottom: "20%",
      top: "10%",
    },
  };

  return (
    <Box>
      <ReactECharts
        option={options}
        style={{
          height,
          width,
          backgroundColor: "var(--white)",
          paddingTop: "12px",
          borderRadius: "12px",
        }}
      />
    </Box>
  );
};

export default PageStatisticsChart;
